import React, { useState, useRef, useEffect } from "react";
import "./Testimonial.css";
import img1 from "../../../../src/assets/testimonial/t1.webp";
import img2 from "../../../../src/assets/testimonial/t2.webp";
import img3 from "../../../../src/assets/testimonial/t3.webp";
import img4 from "../../../../src/assets/testimonial/t4.webp";
import v1 from "../../../../src/assets/testimonial/v1.mp4";
import v2 from "../../../../src/assets/testimonial/v2.mp4";
import v3 from "../../../../src/assets/testimonial/v3.mp4";
import v4 from "../../../../src/assets/testimonial/v4.mp4";
import l1 from "../../../../src/assets/testimonial/testimonial-logo/l1.webp";
import l2 from "../../../../src/assets/testimonial/testimonial-logo/l2.webp";
import l3 from "../../../../src/assets/testimonial/testimonial-logo/l3.webp";
import l4 from "../../../../src/assets/testimonial/testimonial-logo/l4.webp";
import AuthModal from "../../Frontend/Membership/AuthModal/AuthModal";
import Arrow from "../../../../src/assets/icons/arrow.gif"

const testimonials = [
  { id: 1, name: "TEJBIR SINGH ANAND", position: "Managing Director", company: " Holiday Moods Adventures Pvt Ltd", logo: l1, website: "https://www.holidaymoods.in/", review: "Starting his journey in 1997, Tejbir has today become one of the very senior and respected names of the Indian Adventure & Tourism Industry.", image: img4, video: v4 },
  { id: 4, name: "PAPORI BHARATI", position: "India Representative", company: "Northern Finland", logo: l3, website: "https://www.visitfinland.com/en/", review: "Papori is an authority on the Finland Region! With 25 Years of specializing in Arctic & Polar Regions, her inputs are sought after.", image: img1, video: v1 },
  { id: 2, name: "KP SINGH", position: "Founder", company: "Enchanting Experiences", logo: l2, website: "https://enchantingexperiences.in/", review: "In a career spanning almost 40 years, Krishna Pal Singh has been synonymous with Luxury & Heritage Hospitality Chains in India.", image: img3, video: v3 },
  { id: 3, name: "Neelam Chauhan", position: "Project Manager", company: " Liberty International DMC", logo: l4, website: "https://www.liberty-int.com/", review: "Neelam attended an IHN Network Multiplier Event for the first time and is excited to explore business synergies with all of you !!", image: img2, video: v2 },

];

const ClientMedia = ({ item, onOpenModal, isMobile }) => {
  const videoRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    if (!isMobile) {
      setIsHovered(true);
      if (videoRef.current) videoRef.current.play().catch(() => { });
    }
  };

  const handleMouseLeave = () => {
    if (!isMobile) {
      setIsHovered(false);
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
      }
    }
  };

  return (
    <div className="client-media-wrapper">
      {/* Desktop circle with hover video */}
      <div
        className={`media-circle-wrapper ${isHovered ? "active" : ""}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={() => {
    
            onOpenModal(item.video);
          
        }}
      >

        <img
          src={item.image}
          alt={item.name}
          className={`static-image ${isHovered ? "hide" : ""}`}
        />
        {!isMobile && (
          <video
            ref={videoRef}
            src={item.video}
            muted
            loop
            playsInline
            className={`preview-video ${isHovered ? "show" : ""}`}
          />
        )}
      </div>

    </div>
  );
};


const Testimonial = () => {
  const [showAuth, setShowAuth] = useState(false);
  const [activeVideo, setActiveVideo] = useState(null);
  const [isPaused, setIsPaused] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const scrollRef = useRef(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // We double the data to create an infinite loop effect
  const doubledTestimonials = [...testimonials, ...testimonials];

  const scrollNext = () => {
    if (scrollRef.current) {
      const { scrollLeft, offsetWidth, scrollWidth } = scrollRef.current;

      // Check if we are on mobile (matching your CSS media query)
      const isMobile = window.innerWidth <= 768;

      // On mobile, scroll by card width (88%) + gap (16px)
      // On desktop, scroll by 1/3 of container + gap (20px)
      const scrollAmount = isMobile
        ? (offsetWidth * 0.88) + 16
        : (offsetWidth / 3) + 20;

      // Infinite Loop Reset:
      // If we've reached the start of the second half of our doubled list
      if (scrollLeft >= scrollWidth / 2) {
        // Jump back to the start instantly so the user doesn't see a "dead end"
        scrollRef.current.scrollTo({ left: 0, behavior: "instant" });

        // Delay the next smooth scroll slightly to allow the "instant" jump to finish
        setTimeout(() => {
          if (scrollRef.current) {
            scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
          }
        }, 50);
      } else {
        scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
      }
    }
  };

  const scrollPrev = () => {
    if (scrollRef.current) {
      const { scrollLeft, offsetWidth, scrollWidth } = scrollRef.current;

      const isMobile = window.innerWidth <= 768;
      const scrollAmount = isMobile
        ? (offsetWidth * 0.88) + 16
        : (offsetWidth / 3) + 20;

      // If at the very beginning, jump to the middle first
      if (scrollLeft <= 5) {
        scrollRef.current.scrollTo({ left: scrollWidth / 2, behavior: "instant" });
        setTimeout(() => {
          if (scrollRef.current) {
            scrollRef.current.scrollBy({ left: -scrollAmount, behavior: "smooth" });
          }
        }, 50);
      } else {
        scrollRef.current.scrollBy({ left: -scrollAmount, behavior: "smooth" });
      }
    }
  };

  // const scrollNext = () => {
  //   if (scrollRef.current) {
  //     const { scrollLeft, offsetWidth, scrollWidth } = scrollRef.current;
  //     // Updated: Divide by 3 because we now show 3 cards
  //     const scrollAmount = offsetWidth / 3 + 20;

  //     if (scrollLeft + offsetWidth >= scrollWidth - 10) {
  //       scrollRef.current.scrollTo({ left: 0, behavior: "instant" });
  //       scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
  //     } else {
  //       scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
  //     }
  //   }
  // };

  // const scrollPrev = () => {
  //   if (scrollRef.current) {
  //     const { scrollLeft, offsetWidth, scrollWidth } = scrollRef.current;
  //     const scrollAmount = offsetWidth / 3 + 20;

  //     if (scrollLeft <= 10) {
  //       scrollRef.current.scrollTo({ left: scrollWidth / 2, behavior: "instant" });
  //       scrollRef.current.scrollBy({ left: -scrollAmount, behavior: "smooth" });
  //     } else {
  //       scrollRef.current.scrollBy({ left: -scrollAmount, behavior: "smooth" });
  //     }
  //   }
  // };

  // Auto-scroll logic
  useEffect(() => {
    // If a video is playing in the modal, stop the carousel entirely
    if (activeVideo) return;

    const autoScroll = setInterval(() => {
      // Only scroll if the user isn't currently touching/hovering
      if (!isPaused) {
        scrollNext();
      }
    }, 4000);

    return () => clearInterval(autoScroll);
    // Including scrollNext in deps ensures it uses the latest logic
  }, [isPaused, activeVideo]);

  const handleJoinNow = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setTimeout(() => {
      window.dispatchEvent(
        new CustomEvent("OPEN_QUICK_ACCESS", {
          detail: { view: "signup" }
        })
      );
    }, 300);
  };

  return (
    <section className="testimonial-section mt-5">
      <div className="testimonial-container">
        <h1 className="testimonial-title fs-1">Discover the IHN <span className="no-break">Experience!</span></h1>

        <div className="testimonial-main">
          <div className="carousel-wrapper">
            <button className="testimonial-carousel-btn left" onClick={scrollPrev}>
          ❮
            </button>

            <div
              className="testimonial-scroll-area"
              ref={scrollRef}
              onMouseEnter={() => setIsPaused(true)}
              onMouseLeave={() => setIsPaused(false)}
              onTouchStart={() => setIsPaused(true)}
              onTouchEnd={() => {
                setTimeout(() => setIsPaused(false), 1000);
              }}
            >
              <div className="testimonial-row">
                {doubledTestimonials.map((item, index) => (
                  <div className="testimonial-card col-sm-3" key={`${item.id}-${index}`}>
                    <div className="testimonial-card-inner">
                      <ClientMedia item={item} onOpenModal={setActiveVideo} isMobile={isMobile} />
                      <div className="testimonial-text">
                        <div className="testimonial-footer">
                          <h4 className="name-tag text-center">{item.name}</h4>
                          <p className="position-tag text-center mb-1" style={{ color: "#861b68" }}>
                            {item.position}
                          </p>
                          <p className="company-tag text-center">{item.company}</p>
                          <div className="testimonial-logo-container d-flex justify-content-center align-items-center">
                            <a
                              href={item.website}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="testimonial-logo-link"
                            >
                              <img
                                src={item.logo}
                                alt={`${item.company} logo`}
                                className="testimonial-company-logo"
                              />
                            </a>
                          </div>
                        </div>
                        <p className="review-body">"{item.review}"</p>
                      </div>
                      {isMobile && (
                        <button
                          className="view-video-btn"
                          onClick={() => setActiveVideo(item.video)}
                        >
                          VIEW VIDEO
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <button className="testimonial-carousel-btn right" onClick={scrollNext}>
           ❯
            </button>
          </div>

          <button className="join-now testimonial-join-now" onClick={() => setShowAuth(true)}>
            <svg height="24" width="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 0h24v24H0z" fill="none"></path>
              <path d="M5 13c0-5.088 2.903-9.436 7-11.182C16.097 3.564 19 7.912 19 13c0 .823-.076 1.626-.22 2.403l1.94 1.832a.5.5 0 0 1 .095.603l-2.495 4.575a.5.5 0 0 1-.793.114l-2.234-2.234a1 1 0 0 0-.707-.293H9.414a1 1 0 0 0-.707.293l-2.234 2.234a.5.5 0 0 1-.793-.114l-2.495-4.575a.5.5 0 0 1 .095-.603l1.94-1.832C5.077 14.626 5 13.823 5 13zm1.476 6.696l.817-.817A3 3 0 0 1 9.414 18h5.172a3 3 0 0 1 2.121.879l.817.817.982-1.8-1.1-1.04a2 2 0 0 1-.593-1.82c.124-.664.187-1.345.187-2.036 0-3.87-1.995-7.3-5-8.96C8.995 5.7 7 9.13 7 13c0 .691.063 1.372.187 2.037a2 2 0 0 1-.593 1.82l-1.1 1.039.982 1.8zM12 13a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" fill="currentColor"></path>
            </svg>
            <span className="text-light">Join Now</span>
          </button>
        </div>
      </div>

      {/* Full-screen video modal */}
      {activeVideo && (
        <div className="video-modal" onClick={() => setActiveVideo(null)}>
          <div className="modal-inner" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setActiveVideo(null)}>&times;</button>
            <video src={activeVideo} controls autoPlay />
          </div>
        </div>
      )}
      <AuthModal
        isOpen={showAuth}
        onClose={() => setShowAuth(false)}
      />
    </section>

  );
};

export default Testimonial;